/*
 * @Author: hfxie
 * @Date: 2021-12-14 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-04-01 10:10:18
 * @Description: 常量:交互自定义事件接口
 */

const DATA_LOADING = "dataLoading"; // 初始化·主动发起数据加载
const INIT_APP = "gtRefreshIniControlGanttData"; // 初始化·刷新数据
const LOAD_CONTENT = "gtLoadContent"; // 加载分批内容
const BIGER_CELLSCALE = "gtExpand"; // ___ 放大·时间单元格尺寸显示比例 ___
const SMALLER_CELLSCALE = "gtNarrow"; // ___ 缩小·时间单元格尺寸显示比例 ___
const CHANG_SHOW_MODE = "gtShowMode"; // ___ 切换整体视图模式·左中右 ___
const UPDATE_ROWS = "gtRefreshTable"; // 刷新行集合
const SET_CELLSCALE = "gtChangeCellScale"; // ___ 设置时间轴单元格缩放比例 ___
const SET_CELLTYPE = "gtSetCellUnitType"; // 设置时间轴单元格类型·单位
const SET_TIMELINESHOWROWS = "gtSetTimelineShowRows"; // 设置时间轴单元格类型·几行
const SET_CELLSTARTANDEND = "gtSetCellStartAndEnd"; // 设置时间轴起止
const GET_PRINT = "gtPrintType"; // ___ 打印[全部, 当前屏] ___
const CANCEL_PRINT = "gtCancelPrint"; // ___ 取消打印·重置打印状态 ___
const ADD_ROW = "gtRefreshNewTreeRowData"; // ___ 新增行 ___
const DEL_ROW = "gtRefreshDelTreeRowData"; // ___ 删除行___
const UPDATE_EXPAND_STATUS = "gtRefreshExpandNode"; // 刷新展开节点信息
const UPDATE_SELECT_STATUS = "gtRefreshSelectNode"; // 选中·刷新树列表节点信息
const UPDATE_TASKS = "gtRefreshTasks"; // 刷新横道集合
const UPDATE_GANTT_DATA = "gtRefreshGanttData"; // 刷新某个区域集合
const EXCHANGE_GANTT_DATA = "exchangeGanttData"; // 交换·更新2个区域集合
const UPDATE_SELECTSTATUS_AREA = "gtRefreshSelectNodesArea"; // 更新单区域全部选中行集合
const UPDATE_TASK_ONE = "gtRefreshTaskOne"; // *** 刷新单个横道对象 ***

const UPDATE_LINES_STATUS = "gtRefreshIsLineShow"; // ___ 更新 连线是否显示开关 ___
const UPDATE_TIMELINESHOWROWS = "gtRefreshTimelineShowRows"; // ___ 更新 时间轴内容显示几级 ___
const UPDATE_RANKMODE_STATUS = "gtRefreshIsRankMode"; // ___ 更新 时间轴·自增排序显示开关 ___
const UPDATE_WEEKCODEMODE_STATUS = "gtRefreshIsTaskBorderShow"; // ___ 更新 时间轴·周几首字母显示开关 ___
const UPDATE_VERTICALMODE_STATUS = "gtRefreshIsVerticalMode"; // ___ 更新 时间轴二级菜单是否竖直显示开关 ___
const UPDATE_EMPTYBARS_STATUS = "gtRefreshEmptyBarsShow"; // ___ 更新 是否显示空白横道开关 ___
const UPDATE_NORMALBARS_STATUS = "gtRefreshNormalBarsShow"; // ___ 更新 是否显示正常横道开关 ___
const UPDATE_TASKFILTER_3_STATUS = "gtRefreshTaskFilter3"; // ___ 更新 横道显示筛选·关键路径横道 ___
const UPDATE_TASKFILTER_6_STATUS = "gtRefreshTaskFilter6"; // ___ 更新 横道显示筛选·二级关键路径横道 ___
const UPDATE_TASKBORDERRADIUS_STATUS = "gtRefreshNoTaskBorderRadiusShow"; // ___ 更新 常规任务横道是否不显示圆角 ___
const UPDATE_TASKBORDER_STATUS = "gtRefreshIsTaskBorderShow"; // ___ 更新 常规任务横道是否显示黑色边框 ___
const UPDATE_ROWCHECKBOX_STATUS = "gtRefreshIsRowCheckBoxShow"; // ___ 更新 表单行是否显示勾选框 ___
const UPDATE_ROWICON_STATUS = "gtRefreshIsRowIconShow"; // ___ 更新 表单行是否显示名称前置图标 ___
const UPDATE_WEEKEDBG_STATUS = "gtRefreshWeekedBgShow"; // ___ 更新 是否显示非工作日背景 ___
const UPDATE_TREEFONTSIZE = "gtRefreshTreeFontSize"; // ___ 更新 树结构显示 字体大小 ___
const UPDATE_TREEFONTWEIGHT = "gtRefreshTreeFontWeight"; // ___ 更新 树结构显示 字体加粗 ___
const UPDATE_NOGANTTOUTBOXBORDER = "gtRefreshNoGanttOutBoxBorder"; // ___ 更新 无甘特图外边框 ___
const UPDATE_ISBARSELECTROW = "gtRefreshIsBarSelectRow"; // ___ 更新 选择横道是否选中所属行 ___
const UPDATE_ISPRINTMODESHOW = "gtRefreshIsPrintModeShow"; // ___ 更新 是否打印显示模式(不限高·平铺计划区) ___
const UPDATE_PRINTMODEWIDTH = "gtRefreshPrintModeWidth"; // ___ 更新 打印预览模式尺寸比·宽 ___
const UPDATE_PRINTMODEHEIGHT = "gtRefreshPrintModeHeight"; // ___ 更新 打印预览模式尺寸比·高 ___
const UPDATE_PRINTMODESIZE = "gtRefreshPrintModeSize"; // 更新 同时修改打印预览模式尺寸比·宽+高


const UPDATE_BARSFONTSIZE = "gtRefreshBarsFontSize"; // ___ 更新 巴条标签文字大小 ___
const UPDATE_TIMELINEWEEKCODESHOWNUMS = "gtRefreshTimelineWeekCodeShowNums"; // ___ 更新 时间轴周字母显示数量 ___
const UPDATE_TIMELINEFONTNOMAL = "gtRefreshTimeLineFontNomal"; // ___ 更新 时间轴字体大小正常显示 ___
const UPDATE_TIMESLINEHEIGHT = "gtRefreshTimesLineHeight"; // ___ 更新 时间轴·单行行高 ___
const UPDATE_CELLHEIGHT = "gtRefreshCellHeight"; // ___ 更新 横道区·单元行高 ___
const UPDATE_TIMELINEFONTSIZE = "gtRefreshTimelineFontSize"; // ___ 更新 时间轴·字体大小 ___
const UPDATE_LINKLINECOLOR = "gtRefreshLinkLineColor"; // 更新 连线关系·颜色
const UPDATE_TIMELINEBGDATES = "gtRefreshTimelineBgDates"; // ___ 更新 展示背景色日期·集合 ___
const UPDATE_TIMELINEBGDATESCOLOR = "gtRefreshTimelineBgDatesColor"; // ___ 更新 展示背景色日期·背景颜色值 ___



const UPDATE_VIEW_CONFIG = "gtRefreshViewSchem"; // 汇总更新 视图通用项内配置
const UPDATE_SUMMARY = "gtRefreshSummary"; // 设置统计区显示数据及开关
const UPDATE_CONTENT = "gtRefreshContent"; // 局部更新内容（左侧行、右侧巴条）

const UPDATE_GANTT_WIDTH = "gtRefreshGanttWidth"; // ___ 更新 甘特图整体容器尺寸·宽度 ___
const UPDATE_GANTT_HEIGHT = "gtRefreshGanttHeight"; // ___ 更新 甘特图整体容器尺寸·高度 ___
const INIT_SEARCHEDLIST = "gtRefreshSearchedList"; // ___ 初始化·搜索横道结果集合 ___
const UPDATE_SEARCHEDACTNUM = "gtRefreshSearchedActNum"; // ___ 更新展示搜索横道结果集合下标 ___
const CLOSE_SEARCHEDLIST = "gtCloseSearch"; // ___ 关闭·重置搜索横道结果集合 ___


const InConst = {
  DATA_LOADING,
  INIT_APP,
  LOAD_CONTENT,
  BIGER_CELLSCALE,
  SMALLER_CELLSCALE,
  CHANG_SHOW_MODE,
  UPDATE_ROWS,
  SET_CELLSCALE,
  SET_CELLTYPE,
  SET_TIMELINESHOWROWS,
  SET_CELLSTARTANDEND,
  GET_PRINT,
  CANCEL_PRINT,
  ADD_ROW,
  DEL_ROW,
  UPDATE_EXPAND_STATUS,
  UPDATE_SELECT_STATUS,
  UPDATE_TASKS,
  UPDATE_GANTT_DATA,
  EXCHANGE_GANTT_DATA,
  UPDATE_SELECTSTATUS_AREA,
  UPDATE_TASK_ONE,

  UPDATE_LINES_STATUS,
  UPDATE_TIMELINESHOWROWS,
  UPDATE_RANKMODE_STATUS,
  UPDATE_WEEKCODEMODE_STATUS,
  UPDATE_VERTICALMODE_STATUS,
  UPDATE_EMPTYBARS_STATUS,
  UPDATE_NORMALBARS_STATUS,
  UPDATE_TASKFILTER_3_STATUS,
  UPDATE_TASKFILTER_6_STATUS,
  UPDATE_TASKBORDERRADIUS_STATUS,
  UPDATE_TASKBORDER_STATUS,
  UPDATE_ROWCHECKBOX_STATUS,
  UPDATE_ROWICON_STATUS,
  UPDATE_WEEKEDBG_STATUS,
  UPDATE_TREEFONTSIZE,
  UPDATE_TREEFONTWEIGHT,
  UPDATE_NOGANTTOUTBOXBORDER,
  UPDATE_ISBARSELECTROW,
  UPDATE_ISPRINTMODESHOW,
  UPDATE_PRINTMODEWIDTH,
  UPDATE_PRINTMODEHEIGHT,
  UPDATE_PRINTMODESIZE,

  UPDATE_BARSFONTSIZE,
  UPDATE_TIMELINEWEEKCODESHOWNUMS,
  UPDATE_TIMELINEFONTNOMAL,
  UPDATE_TIMESLINEHEIGHT,
  UPDATE_CELLHEIGHT,
  UPDATE_TIMELINEFONTSIZE,
  UPDATE_LINKLINECOLOR,
  UPDATE_TIMELINEBGDATES,
  UPDATE_TIMELINEBGDATESCOLOR,



  UPDATE_VIEW_CONFIG,
  UPDATE_SUMMARY,
  UPDATE_CONTENT,

  UPDATE_GANTT_WIDTH,
  UPDATE_GANTT_HEIGHT,
  INIT_SEARCHEDLIST,
  UPDATE_SEARCHEDACTNUM,
  CLOSE_SEARCHEDLIST,

};

export default InConst;
